"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentPlan_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Location_1 = require("./Location");
var Patient_1 = require("./Patient");
var PatientPaymentMethod_1 = require("./PatientPaymentMethod");
var PaymentPlanSchedule_1 = require("./PaymentPlanSchedule");
var OrthoContractStatus_1 = require("./OrthoContractStatus");
var PaymentPlan_Factory = /** @class */ (function () {
    function PaymentPlan_Factory() {
    }
    PaymentPlan_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ActualStartDate: Date_Factory_1.Date_Factory.CreateIncoming(model.ActualStartDate, { ignoreTimePortion: true }),
            Amount: model.Amount,
            AmountRemaining: model.AmountRemaining,
            Delay: model.Delay,
            Description: model.Description,
            ExpectedNow: model.ExpectedNow,
            Location: Location_1.Location_Factory.CreateIncoming(model.Location),
            LocationId: model.LocationId,
            Patient: Patient_1.Patient_Factory.CreateIncoming(model.Patient),
            PatientId: model.PatientId,
            PatientPaymentMethod: PatientPaymentMethod_1.PatientPaymentMethod_Factory.CreateIncoming(model.PatientPaymentMethod),
            PatientPaymentMethodId: model.PatientPaymentMethodId,
            PatientSignatureDate: Date_Factory_1.Date_Factory.CreateIncoming(model.PatientSignatureDate),
            PatientSignatureFileId: model.PatientSignatureFileId,
            PaymentPlanSchedules: model.PaymentPlanSchedules && model.PaymentPlanSchedules.map(function (i) { return PaymentPlanSchedule_1.PaymentPlanSchedule_Factory.CreateIncoming(i); }),
            PlanStatus: OrthoContractStatus_1.OrthoContractStatus_Factory.CreateIncoming(model.PlanStatus),
            PlanStatusCode: model.PlanStatusCode,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SurchargePercent: model.SurchargePercent,
            SurchargeWaived: model.SurchargeWaived,
        };
        return result;
    };
    PaymentPlan_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ActualStartDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.ActualStartDate, { ignoreTimePortion: true }),
            Amount: model.Amount,
            AmountRemaining: model.AmountRemaining,
            Delay: model.Delay,
            Description: model.Description,
            ExpectedNow: model.ExpectedNow,
            Location: Location_1.Location_Factory.CreateOutgoing(model.Location),
            LocationId: model.LocationId,
            Patient: Patient_1.Patient_Factory.CreateOutgoing(model.Patient),
            PatientId: model.PatientId,
            PatientPaymentMethod: PatientPaymentMethod_1.PatientPaymentMethod_Factory.CreateOutgoing(model.PatientPaymentMethod),
            PatientPaymentMethodId: model.PatientPaymentMethodId,
            PatientSignatureDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.PatientSignatureDate),
            PatientSignatureFileId: model.PatientSignatureFileId,
            PaymentPlanSchedules: model.PaymentPlanSchedules && model.PaymentPlanSchedules.map(function (i) { return PaymentPlanSchedule_1.PaymentPlanSchedule_Factory.CreateOutgoing(i); }),
            PlanStatus: OrthoContractStatus_1.OrthoContractStatus_Factory.CreateOutgoing(model.PlanStatus),
            PlanStatusCode: model.PlanStatusCode,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SurchargePercent: model.SurchargePercent,
            SurchargeWaived: model.SurchargeWaived,
        };
        return result;
    };
    return PaymentPlan_Factory;
}());
exports.PaymentPlan_Factory = PaymentPlan_Factory;
